import { UserRole } from 'generated/graphql';

export const registerInitialState = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  role: UserRole.ProductManagement,
};
